<template>
  <Navbar />
  <div class="content-wrapper">
    <div class="main-content overflow-hidden" v-if="!loading">
      <!--Start Of Heading -->
      <header >
        <div class="heading-container" >
          <div>
            <div style="width: 100%; height: 350px">
              <img :src="cover" class="w-100" style="object-fit: cover;width: inherit;height: inherit;">
            </div>
            <div class="container mt-4 " >
              <!-- <div class="container mt-4 pb-50" style="border-bottom: 1px solid #ddd;"> -->
              <div class="sectionTitle pb-20">
                <h1 class="sectionTitle__title mt-5 mb-0 pt-2"> {{ title }} </h1>
              </div>
              <div>
                <div class="subheading mb-3 " v-html="description"></div>

                <!------coupon section-----------
                <div class="coupon sidebar-recent">
                 
                  <form class="d-flex justify-content-between align-items-center gap-10 flex-column flex-md-row " style="width: 30vw;"
                    @submit.prevent="sendCoupon">
                    <input type="text" class="form-control rounded-8 " style="padding: 13px;" :placeholder="$t('enter-coupon')"
                      v-model="couponCode" />
                    <button type="submit" class="button capitalize main-button">
                      {{ $t('apply') }}
                    </button>
                  </form>
                </div>
                --------------------->
                <!--- Start Of Pricing section ------------>
                <div class="d-flex gap-4">
                  <!----monthly Pricing -->
                <div class="mb-3">
                  <div class="d-flex flex-column align-items-start pb-10 pt-2 price">
                    <span class="pt-1"
                      :class="pricing?.monthly.original_price - pricing.monthly?.price !== 0 ? 'fw-700 price-orginial d-inline-block text-18' : 'd-none'">
                      {{ pricing?.monthly.price }} 
                      {{ pricing?.monthly.currency }} / {{$t('month')}}
                    </span>

                    <span class="pt-1"
                      :class="pricing?.monthly.original_price - pricing?.monthly.price !== 0 ? 'fw-400 d-inline-block exprience line-through text-14' : 'fw-700 price-orginial '">
                      {{ pricing?.monthly.original_price }}
                      {{ pricing?.monthly.currency }} / {{$t('month')}}
                    </span>
                  </div>
                </div>
                <!--Yearly pricing-->
                <div class="mb-3">
                  <div class="d-flex flex-column align-items-start pb-10 pt-2 price">
                    <span class="pt-1"
                      :class="pricing?.yearly.original_price - pricing.yearly?.price !== 0 ? 'fw-700 price-orginial d-inline-block text-18' : 'd-none'">
                      {{ pricing?.yearly.price }} 
                      {{ pricing?.yearly.currency }} / {{$t('year')}}
                    </span>

                    <span class="pt-1"
                      :class="pricing?.yearly.original_price - pricing?.yearly.price !== 0 ? 'fw-400 d-inline-block exprience line-through text-14' : 'fw-700 price-orginial '">
                      {{ pricing?.yearly.original_price }}
                      {{ pricing?.yearly.currency }} / {{$t('year')}}
                    </span>
                  </div>
                </div>
                </div>
                <!---- End Of Pricing section ------------->
                <a class="main-button d-inline-flex justify-content-center align-items-center mt-4"
                  style="width: 200px;" :href="purchaseLink"> {{ $t('purchase') }} </a>
              </div>
            </div>

          </div>

        </div>
      </header>
      <!--End Of Heading -->

      <!--Start Of packages-->
      <div class="container pt-40 mt-4">
        <PackagesList :courses="courses" />
      </div>
      <!--End Of packages-->
    </div>
    <section v-else>
      <loader />
    </section>
    <FooterItem />
  </div>
</template>

<script>
import AOS from "aos";
import Navbar from "@/components/Layout/Navbar.vue";
import FooterItem from "@/components/Layout/FooterItem.vue";
import Loader from "@/components/common/Loader.vue";
import { useHead } from "@vueuse/head";
import { mapGetters } from "vuex";
import PackagesList from "@/components/courses/PackagesList.vue";
import store from "@/store";
import { getBundleContent } from "@/Services/api/BundlesService";
export default {
  components: {
    Navbar,
    Loader,
    PackagesList,
    FooterItem,
  },
  data() {
    return {
      courses: [],
      loading: false,
      title: '',
      description: '',
      cover: '',
      couponCode: "",
      purchaseLink: '',
      pricing : null
    }
  },
  computed: {
    ...mapGetters(["currentLanguage"]),
    isAuthenticated() {
      return store.getters.isAuthenticated
    },
    bundleId() {
      return this.$route.params.id;
    },
    filterCriteria() {
      return {
        language: this.currentLanguage,
        bundle: this.bundleId,
      };
    }
  },
  methods: {
    sendCoupon() {
      console.log(this.couponCode);
    },
    async getBundleDetails() {
      try {
        this.loading = true;
        const response = await getBundleContent(this.bundleId);
        this.courses = response.data.courses
        this.title = response.data.title
        this.description = response.data.description
        this.cover = response.data.cover
        this.purchaseLink = response.data.purchase_link
        this.pricing = response.data.pricing
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false;
      }
    },
    updateHeadMeta() {
      const title =
        this.currentLanguage === "ar"
          ? "الدورات التدريبية - Planning Force | ابدأ رحلتك التعليمية الآن"
          : "Courses - Planning Force | Start Your Learning Journey Now";

      const description =
        this.currentLanguage === "ar"
          ? "اكتشف مجموعة واسعة من الدورات التدريبية في مختلف المجالات لمساعدتك على تطوير مهاراتك وتحقيق أهدافك المهنية والشخصية."
          : "Explore a wide range of courses across various fields to help you develop your skills and achieve your professional and personal goals.";

      const keywords =
        this.currentLanguage === "ar"
          ? "الدورات التدريبية, التعليم الإلكتروني, تطوير المهارات, التعلم, Planning Force"
          : "courses, e-learning, skill development, learning, Planning Force";

      useHead({
        title: title,
        meta: [
          { name: "description", content: description },
          { name: "keywords", content: keywords },
          { name: "robots", content: "index, follow" },
          {
            name: "author",
            content:
              this.currentLanguage === "ar"
                ? "معهد Planning Force العالي للتدريب"
                : "Planning Force High Institute for Training",
          },
          {
            name: "language",
            content: this.currentLanguage === "ar" ? "ar" : "en",
          },

          // Open Graph meta tags
          { property: "og:title", content: title },
          { property: "og:description", content: description },
          {
            property: "og:image",
            content: "https://example.com/courses-og-image.jpg",
          }, // Replace with your courses page image URL
          { property: "og:url", content: "https://example.com/courses" }, // Replace with your courses page URL
          { property: "og:type", content: "website" },

          // Twitter Card meta tags
          { name: "twitter:card", content: "summary_large_image" },
          { name: "twitter:title", content: title },
          { name: "twitter:description", content: description },
          {
            name: "twitter:image",
            content: "https://example.com/courses-twitter-image.jpg",
          }, // Replace with your courses page image URL
        ],
      });
    },
  },
  watch: {
    currentLanguage: {
      handler(newLang, oldLang) {
        //  this.language = newLang;
        this.updateHeadMeta();
        store.dispatch("categoriesList");
      },
      immediate: true, // Run the handler immediately when the component is mounted
    },

    filterCriteria: {
      handler(newCriteria, oldCriteria) {
        this.getBundleDetails()
      },
      immediate: true, // Run the handler immediately when the component is mounted
    },
  },
  mounted() {
    this.updateHeadMeta();
    //this.getCourses();
    AOS.init({
      duration: 1000, // Animation duration
      once: true, // Whether animation should happen only once
    });
  },
};
</script>